<template>
  <div class="client-image__wrapper">
    <img v-if="clientLogo" class="client-image" :src="clientLogo" alt="Client logo">
    <h4 v-else>{{clientName}}</h4>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    name: 'app-logo',
    computed: {
      ...mapState({
        clientLogo: state => state.config.settings.app_image,
        clientName: state => state.config.settings.app_name || '',
      })
    }
  }
</script>
<style scoped>
  .client-image__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -15px;
  }

  .client-image {
    min-height: 20px;
    max-height: 90px;
    width: auto;
  }
</style>
